module.exports = __webpack_public_path__ + "img/user_profile_3.441e3977.png";